import configureStore from './configureStore';
export * from './configureStore';

export default configureStore;
